import { Head } from "@inertiajs/react";
import { Mail } from "lucide-react";

export default function MagicLinkSent({ email }: { email: string }) {
  return (
    <>
      <Head title="Verifique seu email — fotoCerta" />

      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="mx-auto max-w-sm text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <Mail size={32} />
          </div>

          <h1 className="text-2xl font-bold text-foreground">Verifique seu email</h1>

          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
            Se existe uma conta com{" "}
            <span className="font-medium text-foreground">{email}</span>, enviamos
            um link de acesso. Verifique sua caixa de entrada.
          </p>

          <p className="mt-6 text-xs text-muted-foreground">
            O link expira em 15 minutos.{" "}
            <a href="/session/new" className="text-primary hover:underline">
              Voltar ao login
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
